<template>
  <a
    :class="checkSingle"
    :href="link"
    target="_top"
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true
    }"
  >
    <div class="initiative__vignette">
      <img v-if="isVisible" :src="imgUrl" alt />
    </div>

    <div class="initiative__text">
      <div class="initiative__themes">{{ themes }}</div>
      <div class="initiative__title">{{ title }}</div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'Initiative',
  props: {
    domain: String,
    single: {
      type: [String, Boolean],
      default: false
    },
    vignette: String,
    themes: String,
    title: String,
    link: String
  },
  data() {
    return {
      isVisible: false
    };
  },
  computed: {
    checkSingle() {
      return this.single == true
        ? 'initiative initiative--single'
        : 'initiative';
    },
    imgUrl() {
      return this.domain + '/' + this.vignette;
    }
  },
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible && this.vignette !== '') {
        this.isVisible = isVisible;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.initiative {
  display: flex;
  justify-content: space-between;
  margin: 1em;
  padding-bottom: 1em;
  border-bottom: 1px solid rgb(255, 255, 255);
  color: rgb(255, 255, 255);
  text-decoration: none;

  &--single {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 195px;
    margin: 37px 11px 25px;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  &__vignette {
    width: 170px;
    height: 114px;
    background: #eee url('../assets/initiative_thumb_default.png') no-repeat
      center center / contain;

    img,
    svg {
      width: 100%;
      height: auto;
      vertical-align: bottom;
    }
  }

  &__text {
    .initiative:not(.initiative--single) & {
      width: calc(100% - 170px - 13px);
    }

    .initiative--single & {
      max-width: 170px;
      text-align: left;
    }
  }

  &__themes {
    font-family: Ubuntu;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 1;
    margin-bottom: 1.27em;

    .initiative--single & {
      margin-top: 1em;
    }
  }

  &__title {
    font-family: Ubuntu;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
  }
}
</style>
